export const paymentTypes = {
    1: "پرداخت از کیف پول",
    2: "پرداخت اینترنتی"
}